import React, { useState } from "react";
import moment from "moment";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import EditableDateRangeFilter from "./EditableDateRangeFilter";

const DATE_FORMAT = "MM/DD/YYYY";

export default function DateRangeFilterModal({ value, title, description, onClose, onSave }) {
  const [startDate, setStartDate] = useState(
    value?.start_date ? moment(value.start_date).format(DATE_FORMAT) : null
  );
  const [endDate, setEndDate] = useState(
    value?.end_date ? moment(value.end_date).format(DATE_FORMAT) : null
  );

  const handleSave = () => {
    const dateRange = {
      start_date: startDate,
      end_date: endDate,
    };

    onSave(dateRange);
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog open onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography fontSize={20} fontWeight={500} color="text.primary" align="center">
          {title}
        </Typography>
        <IconButton
          onClick={handleCancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
          {description}
        </Typography>
        <EditableDateRangeFilter
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={setStartDate}
          onEndDateChange={setEndDate}
          spacing={2}
          mb={0}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={!startDate || !endDate}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
